exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apiKeyboardBtn{font-size:1.5rem;color:#fff}#modal-2>div{margin-left:20px;margin-top:6%}#modal-2___BV_modal_content_{width:600px;color:#fff;background-color:rgba(128,0,0,.9)!important}#keyboard{height:40em;overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7626d9c9","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/commons/APIKeyboard.vue
// module id = 690
// module chunks = 0